import { Chip, List, ListElement } from '@farol-ds/react'
import { LineScroll, useLineScroll } from '@jusbrasil-web/shared-line-scroll'
import { useRef } from 'react'

import printStyles from '../../print.module.scss'
import styles from './chips-list.module.scss'

export interface ChipsListProps {
  chips: string[]
}

export function ChipsList({ chips }: ChipsListProps) {
  const lineScrollListRef = useRef<ListElement>(null)
  const {
    boundaryRef: lineScrollBoundaryRef,
    arrowLeftRef: lineScrollArrowLeftRef,
    arrowRightRef: lineScrollArrowRightRef,
    scrollToDirection,
    captureTargetRef,
  } = useLineScroll({ listRef: lineScrollListRef, scrollStrategy: 'visible-width' })
  if (chips.length === 0) {
    return null
  }
  return (
    <LineScroll className={printStyles.unprintable}>
      <LineScroll.ArrowLeft ref={lineScrollArrowLeftRef} scrollToDirection={scrollToDirection} />
      <LineScroll.Boundary
        ref={lineScrollBoundaryRef}
        containerClassName={styles.lineScrollContainer}
      >
        <List className={styles.chipsList} ref={lineScrollListRef}>
          {chips.map((chip, index) => {
            return (
              <List.Item key={index} ref={captureTargetRef}>
                <Chip size="md" className={styles.chip} title={chip} unstable_truncate>
                  {chip}
                </Chip>
              </List.Item>
            )
          })}
        </List>
      </LineScroll.Boundary>
      <LineScroll.ArrowRight ref={lineScrollArrowRightRef} scrollToDirection={scrollToDirection} />
    </LineScroll>
  )
}
